module.exports = __webpack_public_path__ + "img/primary_logo.1cb91c3c.png";